import { ReactElement, useState } from 'react'
import {
  FAS_CHEVRON_DOWN,
  FAS_CHEVRON_RIGHT,
  FAS_CHEVRON_UP
} from 'const/icons'
import Collapse from 'syf-component-library/ui/atoms/Collapse/Collapse'
import { Notification } from 'typings/notifications'
import {
  AccountList,
  AccountName,
  CollapseButton,
  CollapseIcon,
  NotificationActionLink,
  NotificationActionText,
  NotificationCardBody,
  NotificationCardHeader,
  NotificationCardWrapper,
  NotificationDescription,
  NotificationExclamation,
  NotificationTitle,
  RightAngleIcon,
  RoundCircle
} from './subcomponents'

type NotificationCardProps = Notification

const NotificationCard = ({
  accountList,
  clickAnalytics,
  description,
  handleClickHandler,
  id,
  linkTitle,
  title
}: NotificationCardProps): ReactElement => {
  const [open, setOpen] = useState(false)
  const collapseIcon = open ? FAS_CHEVRON_UP : FAS_CHEVRON_DOWN
  const handleClick = () => setOpen(!open)

  if (accountList?.length <= 0) {
    return null
  }

  return (
    <NotificationCardWrapper data-cy={id}>
      <NotificationCardHeader onClick={handleClick}>
        <CollapseButton
          aria-expanded={open}
          data-cy="notification-center-collapse-button"
        >
          <RoundCircle>
            <NotificationExclamation
              data-test="notification-center-exclamation"
              weight="bold"
            >
              !
            </NotificationExclamation>
          </RoundCircle>
          <NotificationTitle
            data-cy="notification-center-attention-title"
            data-test="notification-center-attention-title"
            weight="bold"
          >
            {title}
          </NotificationTitle>
          <CollapseIcon icon={collapseIcon} />
        </CollapseButton>
      </NotificationCardHeader>
      <Collapse expand={open} id="collapse-id">
        <NotificationCardBody data-cy="notification-center-issue-body">
          <NotificationDescription
            data-cy="notification-center-issue-description"
            data-test="notification-center-issue-description"
          >
            {description}
            <AccountList
              data-cy="notification-center-accounts"
              data-test="notification-center-accounts"
            >
              {accountList?.map(({ accountId, accountName }) => (
                <AccountName
                  data-cy="notification-center-account-name"
                  data-test="notification-center-account-name"
                  key={accountId}
                >
                  {accountName}
                </AccountName>
              ))}
            </AccountList>
          </NotificationDescription>
          <NotificationActionLink
            {...clickAnalytics}
            data-cy="notification-center-review-btn"
            data-test="notification-center-review-btn"
            onClick={handleClickHandler}
          >
            <NotificationActionText>{linkTitle}</NotificationActionText>
            <RightAngleIcon icon={FAS_CHEVRON_RIGHT} />
          </NotificationActionLink>
        </NotificationCardBody>
      </Collapse>
    </NotificationCardWrapper>
  )
}

export default NotificationCard
